// *******************************************************************************
// Registration form validation
// *******************************************************************************

document.addEventListener('DOMContentLoaded', () => {
  const regForms = document.querySelectorAll('.registration-form');
  const registrationForm = document.getElementById('registration-form');

  if (registrationForm) {
    const axiosRegisterAction = (formData) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(localData.captchaSiteKey, {action: formData.action}).then((token) => {
          const formErrorMessage = registrationForm.querySelector('.form-error-message');
          formErrorMessage.classList.remove('is-validation-failed');
          formErrorMessage.innerHTML = formErrorMessage.getAttribute('data-generic-error-message');
          const formDataInput = new FormData();
          formDataInput.append('action', formData.registration_action);
          formDataInput.append('inputs', JSON.stringify(formData));
          formDataInput.append('lang', localData.lang);
          formDataInput.append('id', localData.id);
          formDataInput.append('token', token);
          axios
            .post(localData.siteURL, formDataInput, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then((response) => {
              if (response.status === 200) {
                window.location.replace(response.data.data.url);
              }
            })
            .catch((err) => {
              formErrorMessage.innerHTML = err.response.data.data.msg;
              formErrorMessage.classList.add('is-validation-failed');
            });
        });
      });
    };

    let message1 = '';
    let message2 = '';
    if (registrationForm.querySelector('[name="signup_password"]')) {
      message1 = registrationForm.querySelector('[name="signup_password"]').getAttribute('data-error-message');
      message2 = registrationForm.querySelector('[name="signup_confirm_password"]').getAttribute('data-error-message');
    }

    const fv = FormValidation.formValidation(registrationForm, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {
        signup_password: {
          validators: {
            regexp: {
              regexp: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/g,
              message: message1,
            },
          },
        },
        signup_confirm_password: {
          validators: {
            identical: {
              compare() {
                return registrationForm.querySelector('[name="signup_password"]').value;
              },
              message: message2,
            },
          },
        },
      },
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.mod-input,.checkbox'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger(),
        excluded: new FormValidation.plugins.Excluded(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        // e.element presents the field element
        // e.valid indicates the field is valid or not

        // Get the field value
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox');
        if (value === '') {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': true,
          });
        } else {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': false,
          });
        }

        FormValidation.utils.classSet(container, {
          'is-validation-failed': !e.valid,
        });
      })
      .on('core.form.valid', () => {
        const formData = {};
        registrationForm.querySelectorAll('input, textarea').forEach((input) => {
          if (input.type === 'checkbox') {
            formData[input.name] = input.checked;
          } else {
            formData[input.name] = input.value.trim();
          }
        });
        axiosRegisterAction(formData);
      });

    initPostCodeHelper(fv, registrationForm);
  }

  const toggleHideClass = (element, toggle) => {
    element.classList.toggle('hide', toggle);
  };

  // Open company info form
  regForms.forEach((regForm) => {
    const companyInfoCheckbox = regForm.querySelector('.company-info-checkbox input');
    const companyInfoFields = regForm.querySelector('.company-info-fields');
    const shippingAddressCheckbox = regForm.querySelector('.shipping-address-checkbox input');
    const shippingAddressFields = regForm.querySelector('.shipping-address-fields');

    if (companyInfoCheckbox) {
      companyInfoCheckbox.addEventListener('change', (event) => {
        toggleHideClass(companyInfoFields, !event.currentTarget.checked);
      });
    }

    if (shippingAddressCheckbox) {
      shippingAddressCheckbox.addEventListener('change', (event) => {
        toggleHideClass(shippingAddressFields, !event.currentTarget.checked);
      });
    }
  });
});
